import { render, staticRenderFns } from "./TeachersInfo.vue?vue&type=template&id=7512898b&"
import script from "./TeachersInfo.vue?vue&type=script&lang=ts&"
export * from "./TeachersInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TeachersInfo.vue?vue&type=style&index=0&id=7512898b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports